import { IonContent, IonRefresher, IonRefresherContent } from "@ionic/react";
import { useQuery } from "@tanstack/react-query";
import { t } from "i18next";
import React, { useContext, useEffect, useState } from "react";
import { PageHeader } from "../../components/PageHeader";
import BasicTemplate from "../../components/PageTemplates/BasicTemplate";
import { AuthenticatedUserContext } from "../../contexts/AuthenticatedUserContext";
import { ApiService } from "../../services";
import { File } from "./File";
import { FolderView } from "./FolderView";

export interface Folder {
  id: number;
  title: string;
  subfolders: Folder[];
  children: File[];
  files_count: number;
}

export interface FileType {
  id: number;
  title: string;
  url: string;
}

export const Resources = (props: any) => {
  const [title, setTitle] = useState<string>("");
  const [isRoot, setIsRoot] = useState<boolean>(false);
  const { showAllFiles } = useContext(AuthenticatedUserContext);

  const { isPending, data, refetch } = useQuery({
    queryKey: ["folder", props.match.params?.folder, showAllFiles],
    queryFn: async () => {
      const folderId = props.match.params?.folder || "";
      return await ApiService.get(`resources/${folderId}?showAll=${showAllFiles ? 1 : 0}`);
    },
  });

  useEffect(() => {
    setIsRoot(props.match.params?.folder === undefined);
  }, [props.match.params?.folder]);

  useEffect(() => {
    setTitle(props.match.params?.name);
  }, [props.match.params?.name]);

  const handleRefresh = (event: CustomEvent) => {
    refetch().finally(event.detail.complete);
  };

  return (
    <BasicTemplate className="resources" hideHeader={false} hideBackButton={false} title={title}>
      <IonContent className={"ion-padding"}>
        <PageHeader collapse={"condense"}>{isRoot ? t("drive") : data?.data?.title}</PageHeader>

        <IonRefresher slot={"fixed"} onIonRefresh={handleRefresh}>
          <IonRefresherContent></IonRefresherContent>
        </IonRefresher>

        <FolderView isPending={isPending} contents={data?.data} />
      </IonContent>
    </BasicTemplate>
  );
};
